import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-pa2",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-pa2.component.html",
  styleUrl: "./prefix-pa2.component.less",
})
export class PrefixPa2Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 255;
    this.characters = ALLOWED_CHARACTERS["pa2"];
  }
}
